function cleanText(value) {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

export function findLatLngInText(value) {
  const text = decodeURIComponent(String(value || ''));
  const atMatch = text.match(/@(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)/);
  if (atMatch) return { lat: Number(atMatch[1]), lng: Number(atMatch[2]) };

  const bangMatch = text.match(/!3d(-?\d+(?:\.\d+)?)!4d(-?\d+(?:\.\d+)?)/);
  if (bangMatch) return { lat: Number(bangMatch[1]), lng: Number(bangMatch[2]) };

  const pairMatch = text.match(/(-?\d{1,2}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)/);
  if (pairMatch) {
    const lat = Number(pairMatch[1]);
    const lng = Number(pairMatch[2]);
    if (Math.abs(lat) <= 90 && Math.abs(lng) <= 180) return { lat, lng };
  }
  return null;
}

function nominatimResultToDraft(result) {
  const address = result?.address || {};
  return {
    formattedAddress: result?.display_name || '',
    address: cleanText(
      [
        address.house_number,
        address.road,
        address.neighbourhood || address.suburb || address.quarter,
      ]
        .filter(Boolean)
        .join(', '),
    ) || result?.display_name || '',
    city: address.city || address.town || address.village || address.county || '',
    state: address.state || '',
    country: address.country || 'India',
    postalCode: address.postcode || '',
    latitude: Number(result?.lat),
    longitude: Number(result?.lon),
  };
}

export function draftFromCoords(coords) {
  return {
    formattedAddress: '',
    address: '',
    city: '',
    state: '',
    country: 'India',
    postalCode: '',
    latitude: Number(coords.lat),
    longitude: Number(coords.lng),
  };
}

/**
 * @param {string} text
 */
export async function osmSearchAddress(text) {
  const url = new URL('https://nominatim.openstreetmap.org/search');
  url.searchParams.set('format', 'jsonv2');
  url.searchParams.set('addressdetails', '1');
  url.searchParams.set('limit', '1');
  url.searchParams.set('countrycodes', 'in');
  url.searchParams.set('q', text);
  const response = await fetch(url.toString(), {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) throw new Error('Could not search that address.');
  const data = await response.json();
  const first = Array.isArray(data) ? data[0] : null;
  if (!first) throw new Error('No matching location was found.');
  return nominatimResultToDraft(first);
}

/**
 * @param {{ lat: number, lng: number }} coords
 */
export async function osmReverseGeocode(coords) {
  const url = new URL('https://nominatim.openstreetmap.org/reverse');
  url.searchParams.set('format', 'jsonv2');
  url.searchParams.set('addressdetails', '1');
  url.searchParams.set('lat', String(coords.lat));
  url.searchParams.set('lon', String(coords.lng));
  const response = await fetch(url.toString(), {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) return draftFromCoords(coords);
  const data = await response.json();
  return data?.lat && data?.lon ? nominatimResultToDraft(data) : draftFromCoords(coords);
}

/**
 * @param {string} text
 */
export async function geocodeAddressQuery(text) {
  const trimmed = cleanText(text);
  if (!trimmed) throw new Error('Enter an address or landmark to search.');
  const coords = findLatLngInText(trimmed);
  if (coords) return osmReverseGeocode(coords);
  return osmSearchAddress(trimmed);
}
